var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteJazzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.38054H17.8267C18.8432 7.48971 19.2304 6.02276 18.6834 4.70588L16.4811 5.61607C17.1491 4.38635 16.9603 2.82256 15.9245 1.78165L14.3901 3.31639C14.453 1.98983 13.6931 0.706851 12.3959 0.16945L11.4908 2.3481C11.1036 0.992496 9.85479 0 8.37851 0V2.22222C7.48306 1.23941 6.04066 0.87146 4.74347 1.40886L5.61471 3.51973C4.38529 2.85161 2.82188 3.04043 1.78122 4.07649L3.41239 5.70806C2.0668 5.62092 0.750242 6.38586 0.208132 7.70274L2.24105 8.54515C0.939013 8.95667 0 10.1767 0 11.6195H2.37173C1.30687 12.5006 0.89061 14.0063 1.44724 15.3522L3.44627 14.5243C2.86544 15.7298 3.07841 17.221 4.07551 18.2184L5.75992 16.5335C5.60019 17.9327 6.37464 19.3222 7.73959 19.8886L8.57696 17.8649C9.0271 19.1092 10.2227 20 11.6215 20V17.6761C12.4976 18.7751 14.0271 19.2157 15.3921 18.6492L14.5257 16.5577C15.7309 17.1387 17.2217 16.9257 18.2188 15.9283L16.636 14.3452C18.0106 14.4711 19.3708 13.7013 19.9274 12.3602L17.7638 11.4597C19.061 11.0385 20 9.81845 20 8.38054Z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteJazzIcon);
export default __webpack_public_path__ + "static/media/whiteJazzIcon.70ce4025178c2743dcb32c5608415953.svg";
export { ForwardRef as ReactComponent };